const banks = [
  {
    name: "Komer\u010Dn\xED banka, a.s.",
    code: "0100",
    country: "Czechia"
  },
  {
    name: "\u010Ceskoslovensk\xE1 obchodn\xED banka, a. s.",
    code: "0300",
    country: "Czechia"
  },
  {
    name: "MONETA Money Bank, a.s.",
    code: "0600",
    country: "Czechia"
  },
  {
    name: "\u010CESK\xC1 N\xC1RODN\xCD BANKA",
    code: "0710",
    country: "Czechia"
  },
  {
    name: "\u010Cesk\xE1 spo\u0159itelna, a.s.",
    code: "0800",
    country: "Czechia"
  },
  {
    name: "Fio banka, a.s.",
    code: "2010",
    country: "Czechia"
  },
  {
    name: "Citfin, spo\u0159iteln\xED dru\u017Estvo",
    code: "2060",
    country: "Czechia"
  },
  {
    name: "TRINITY BANK a.s.",
    code: "2070",
    country: "Czechia"
  },
  {
    name: "\u010CSOB Hypote\u010Dn\xED banka, a.s.",
    code: "2100",
    country: "Czechia"
  },
  {
    name: "Pen\u011B\u017En\xED d\u016Fm, spo\u0159iteln\xED dru\u017Estvo",
    code: "2200",
    country: "Czechia"
  },
  {
    name: "Artesa, spo\u0159iteln\xED dru\u017Estvo",
    code: "2220",
    country: "Czechia"
  },
  {
    name: "Banka CREDITAS a.s.",
    code: "2250",
    country: "Czechia"
  },
  {
    name: "NEY spo\u0159iteln\xED dru\u017Estvo",
    code: "2260",
    country: "Czechia"
  },
  {
    name: "Citibank Europe plc, organiza\u010Dn\xED slo\u017Eka",
    code: "2600",
    country: "Czechia"
  },
  {
    name: "UniCredit Bank Czech Republic and Slovakia, a.s.",
    code: "2700",
    country: "Czechia"
  },
  {
    name: "Air Bank a.s.",
    code: "3030",
    country: "Czechia"
  },
  {
    name: "PKO BP S.A., Czech Branch",
    code: "3060",
    country: "Czechia"
  },
  {
    name: "ING Bank N.V.",
    code: "3500",
    country: "Czechia"
  },
  {
    name: "N\xE1rodn\xED rozvojov\xE1 banka, a.s.",
    code: "4300",
    country: "Czechia"
  },
  {
    name: "Raiffeisenbank a.s.",
    code: "5500",
    country: "Czechia"
  },
  {
    name: "J&T BANKA, a.s.",
    code: "5800",
    country: "Czechia"
  },
  {
    name: "PPF banka a.s.",
    code: "6000",
    country: "Czechia"
  },
  {
    name: "COMMERZBANK Aktiengesellschaft, pobo\u010Dka Praha",
    code: "6200",
    country: "Czechia"
  },
  {
    name: "mBank S.A., organiza\u010Dn\xED slo\u017Eka",
    code: "6210",
    country: "Czechia"
  },
  {
    name: "BNP Paribas S.A., pobo\u010Dka \u010Cesk\xE1 republika",
    code: "6300",
    country: "Czechia"
  },
  {
    name: "Partners Banka, a.s.",
    code: "6363",
    country: "Czechia"
  },
  {
    name: "V\u0161eobecn\xE1 \xFAverov\xE1 banka a.s., pobo\u010Dka Praha",
    code: "6700",
    country: "Czechia"
  },
  {
    name: "Sberbank CZ, a.s. v likvidaci",
    code: "6800",
    country: "Czechia"
  },
  {
    name: "Deutsche Bank Aktiengesellschaft Filiale Prag, organiza\u010Dn\xED slo\u017Eka",
    code: "7910",
    country: "Czechia"
  },
  {
    name: "Raiffeisen stavebn\xED spo\u0159itelna a.s.",
    code: "7950",
    country: "Czechia"
  },
  {
    name: "\u010CSOB Stavebn\xED spo\u0159itelna, a.s.",
    code: "7960",
    country: "Czechia"
  },
  {
    name: "MONETA Stavebn\xED Spo\u0159itelna, a.s.",
    code: "7970",
    country: "Czechia"
  },
  {
    name: "Modr\xE1 pyramida stavebn\xED spo\u0159itelna, a.s.",
    code: "7990",
    country: "Czechia"
  },
  {
    name: "Volksbank Raiffeisenbank Nordoberpfalz eG pobo\u010Dka Cheb",
    code: "8030",
    country: "Czechia"
  },
  {
    name: "Oberbank AG pobo\u010Dka \u010Cesk\xE1 republika",
    code: "8040",
    country: "Czechia"
  },
  {
    name: "Stavebn\xED spo\u0159itelna \u010Cesk\xE9 spo\u0159itelny, a.s.",
    code: "8060",
    country: "Czechia"
  },
  {
    name: "\u010Cesk\xE1 exportn\xED banka, a.s.",
    code: "8090",
    country: "Czechia"
  },
  {
    name: "HSBC Continental Europe, Czech Republic",
    code: "8150",
    country: "Czechia"
  },
  {
    name: "Sparkasse Oberlausitz-Niederschlesien",
    code: "8190",
    country: "Czechia"
  },
  {
    name: "FAS finance company s.r.o.",
    code: "8198",
    country: "Czechia"
  },
  {
    name: "Payment execution s.r.o.",
    code: "8220",
    country: "Czechia"
  },
  {
    name: "Bank of China (CEE) Ltd. Prague Branch",
    code: "8250",
    country: "Czechia"
  },
  {
    name: "Bank of Communications Co., Ltd., Prague Branch od\u0161t\u011Bpn\xFD z\xE1vod",
    code: "8255",
    country: "Czechia"
  },
  {
    name: "Industrial and Commercial Bank of China Limited, Prague Branch, od\u0161t\u011Bpn\xFD z\xE1vod",
    code: "8265",
    country: "Czechia"
  },
  {
    name: "Multitude Bank p.l.c.",
    code: "8500",
    country: "Czechia"
  }
];

const countries = [
  {
    code2: "AF",
    code3: "AFG",
    currency: "USD",
    phoneCode: "+93",
    name: "Afghanistan",
    native: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
    vat: 10,
    sanctions: true
  },
  {
    code2: "AL",
    code3: "ALB",
    currency: "EUR",
    phoneCode: "+355",
    name: "Albania",
    native: "Shqip\xEBria",
    vat: 20
  },
  {
    code2: "DZ",
    code3: "DZA",
    currency: "USD",
    phoneCode: "+213",
    name: "Algeria",
    native: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
    vat: 19
  },
  {
    code2: "AS",
    code3: "ASM",
    currency: "USD",
    phoneCode: "+1",
    name: "American Samoa",
    native: "American Samoa",
    vat: 15
  },
  {
    code2: "AD",
    code3: "AND",
    currency: "EUR",
    phoneCode: "+376",
    name: "Andorra",
    native: "Andorra",
    vat: 4.5
  },
  {
    code2: "AO",
    code3: "AGO",
    currency: "USD",
    phoneCode: "+244",
    name: "Angola",
    native: "Angola",
    vat: 14
  },
  {
    code2: "AG",
    code3: "ATG",
    currency: "USD",
    phoneCode: "+1",
    name: "Antigua and Barbuda",
    native: "Antigua and Barbuda",
    vat: 15
  },
  {
    code2: "AR",
    code3: "ARG",
    currency: "USD",
    phoneCode: "+54",
    name: "Argentina",
    native: "Argentina",
    vat: 21
  },
  {
    code2: "AM",
    code3: "ARM",
    currency: "USD",
    phoneCode: "+374",
    name: "Armenia",
    native: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
    vat: 20
  },
  {
    code2: "AW",
    code3: "ABW",
    currency: "USD",
    phoneCode: "+297",
    name: "Aruba",
    native: "Aruba",
    vat: 2
  },
  {
    code2: "AU",
    code3: "AUS",
    currency: "USD",
    phoneCode: "+61",
    name: "Australia",
    native: "Australia",
    vat: 10
  },
  {
    code2: "AT",
    code3: "AUT",
    currency: "EUR",
    phoneCode: "+43",
    name: "Austria",
    native: "\xD6sterreich",
    vat: 20
  },
  {
    code2: "AZ",
    code3: "AZE",
    currency: "USD",
    phoneCode: "+994",
    name: "Azerbaijan",
    native: "Az\u0259rbaycan",
    vat: 18
  },
  {
    code2: "BS",
    code3: "BHS",
    currency: "USD",
    phoneCode: "+1",
    name: "Bahamas",
    native: "Bahamas",
    vat: 12
  },
  {
    code2: "BH",
    code3: "BHR",
    currency: "USD",
    phoneCode: "+973",
    name: "Bahrain",
    native: "\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
    vat: 10
  },
  {
    code2: "BD",
    code3: "BGD",
    currency: "USD",
    phoneCode: "+880",
    name: "Bangladesh",
    native: "Bangladesh",
    vat: 15
  },
  {
    code2: "BB",
    code3: "BRB",
    currency: "USD",
    phoneCode: "+1",
    name: "Barbados",
    native: "Barbados",
    vat: 17.5,
    sanctions: true
  },
  {
    code2: "BY",
    code3: "BLR",
    currency: "USD",
    phoneCode: "+375",
    name: "Belarus",
    native: "\u0411\u0435\u043B\u0430\u0440\u0443\u0301\u0441\u044C",
    vat: 20
  },
  {
    code2: "BE",
    code3: "BEL",
    currency: "EUR",
    phoneCode: "+32",
    name: "Belgium",
    native: "Belgi\xEB",
    vat: 21
  },
  {
    code2: "BZ",
    code3: "BLZ",
    currency: "USD",
    phoneCode: "+501",
    name: "Belize",
    native: "Belize",
    vat: 12.5
  },
  {
    code2: "BJ",
    code3: "BEN",
    currency: "USD",
    phoneCode: "+229",
    name: "Benin",
    native: "B\xE9nin",
    vat: 18
  },
  {
    code2: "BO",
    code3: "BOL",
    currency: "USD",
    phoneCode: "+591",
    name: "Bolivia",
    native: "Bolivia",
    vat: 13
  },
  {
    code2: "BQ",
    code3: "BES",
    currency: "USD",
    phoneCode: "+599",
    name: "Bonaire",
    native: "Bonaire",
    vat: 8
  },
  {
    code2: "BA",
    code3: "BIH",
    currency: "EUR",
    phoneCode: "+387",
    name: "Bosnia and Herzegovina",
    native: "Bosna i Hercegovina",
    vat: 17
  },
  {
    code2: "BW",
    code3: "BWA",
    currency: "USD",
    phoneCode: "+267",
    name: "Botswana",
    native: "Botswana",
    vat: 14
  },
  {
    code2: "BR",
    code3: "BRA",
    currency: "USD",
    phoneCode: "+55",
    name: "Brazil",
    native: "Brasil",
    vat: 18
  },
  {
    code2: "IO",
    code3: "IOT",
    currency: "USD",
    phoneCode: "+246",
    name: "British Indian Ocean Territory",
    native: "British Indian Ocean Territory",
    vat: 20
  },
  {
    code2: "VG",
    code3: "VGB",
    currency: "USD",
    phoneCode: "+1",
    name: "British Virgin Islands",
    native: "British Virgin Islands",
    vat: 21
  },
  {
    code2: "BG",
    code3: "BGR",
    currency: "BGN",
    phoneCode: "+359",
    name: "Bulgaria",
    native: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
    vat: 20
  },
  {
    code2: "BF",
    code3: "BFA",
    currency: "USD",
    phoneCode: "+226",
    name: "Burkina Faso",
    native: "Burkina Faso",
    vat: 18,
    sanctions: true
  },
  {
    code2: "BI",
    code3: "BDI",
    currency: "USD",
    phoneCode: "+257",
    name: "Burundi",
    native: "Burundi",
    vat: 18
  },
  {
    code2: "KH",
    code3: "KHM",
    currency: "USD",
    phoneCode: "+855",
    name: "Cambodia",
    native: "K\xE2mp\u016Dch\xE9a",
    vat: 10
  },
  {
    code2: "CM",
    code3: "CMR",
    currency: "USD",
    phoneCode: "+237",
    name: "Cameroon",
    native: "Cameroon",
    vat: 19.25,
    sanctions: true
  },
  {
    code2: "CA",
    code3: "CAN",
    currency: "",
    phoneCode: "+1",
    name: "Canada",
    native: "Canada",
    vat: 5
  },
  {
    code2: "CV",
    code3: "CPV",
    currency: "USD",
    phoneCode: "+238",
    name: "Cape Verde",
    native: "Cabo Verde",
    vat: 15
  },
  {
    code2: "CF",
    code3: "CAF",
    currency: "USD",
    phoneCode: "+236",
    name: "Central African Republic",
    native: "K\xF6d\xF6r\xF6s\xEAse t\xEE B\xEAafr\xEEka",
    vat: 19
  },
  {
    code2: "TD",
    code3: "TCD",
    currency: "USD",
    phoneCode: "+235",
    name: "Chad",
    native: "Tchad",
    vat: 18
  },
  {
    code2: "CL",
    code3: "CHL",
    currency: "USD",
    phoneCode: "+56",
    name: "Chile",
    native: "Chile",
    vat: 19
  },
  {
    code2: "CN",
    code3: "CHN",
    currency: "USD",
    phoneCode: "+86",
    name: "China",
    native: "\u4E2D\u56FD",
    vat: 13
  },
  {
    code2: "CO",
    code3: "COL",
    currency: "USD",
    phoneCode: "+57",
    name: "Colombia",
    native: "Colombia",
    vat: 19
  },
  {
    code2: "KM",
    code3: "COM",
    currency: "USD",
    phoneCode: "+269",
    name: "Comoros",
    native: "Komori",
    vat: 10
  },
  {
    code2: "CK",
    code3: "COK",
    currency: "USD",
    phoneCode: "+682",
    name: "Cook Islands",
    native: "Cook Islands",
    vat: 15
  },
  {
    code2: "CR",
    code3: "CRI",
    currency: "USD",
    phoneCode: "+506",
    name: "Costa Rica",
    native: "Costa Rica",
    vat: 13
  },
  {
    code2: "HR",
    code3: "HRV",
    currency: "HRK",
    phoneCode: "+385",
    name: "Croatia",
    native: "Hrvatska",
    vat: 25
  },
  {
    code2: "CW",
    code3: "CUW",
    currency: "USD",
    phoneCode: "+599",
    name: "Curacao",
    native: "Cura\xE7ao",
    vat: 6
  },
  {
    code2: "CY",
    code3: "CYP",
    currency: "EUR",
    phoneCode: "+357",
    name: "Cyprus",
    native: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2",
    vat: 19
  },
  {
    code2: "CZ",
    code3: "CZE",
    currency: "CZK",
    phoneCode: "+420",
    name: "Czechia",
    native: "\u010Cesko",
    vat: 21,
    priority: 1
  },
  {
    code2: "CD",
    code3: "COD",
    currency: "USD",
    phoneCode: "+243",
    name: "Democratic Republic of the Congo",
    native: "R\xE9publique d\xE9mocratique du Congo",
    vat: 18,
    sanctions: true
  },
  {
    code2: "DK",
    code3: "DNK",
    currency: "DKK",
    phoneCode: "+45",
    name: "Denmark",
    native: "Danmark",
    vat: 25
  },
  {
    code2: "DJ",
    code3: "DJI",
    currency: "USD",
    phoneCode: "+253",
    name: "Djibouti",
    native: "Djibouti",
    vat: 10
  },
  {
    code2: "DM",
    code3: "DMA",
    currency: "USD",
    phoneCode: "+1",
    name: "Dominica",
    native: "Dominica",
    vat: 15
  },
  {
    code2: "DO",
    code3: "DOM",
    currency: "USD",
    phoneCode: "+809",
    name: "Dominican Republic",
    native: "Rep\xFAblica Dominicana",
    vat: 18
  },
  {
    code2: "TL",
    code3: "TLS",
    currency: "USD",
    phoneCode: "+670",
    name: "East Timor",
    native: "Timor-Leste",
    vat: 10
  },
  {
    code2: "EC",
    code3: "ECU",
    currency: "USD",
    phoneCode: "+593",
    name: "Ecuador",
    native: "Ecuador",
    vat: 12
  },
  {
    code2: "EG",
    code3: "EGY",
    currency: "USD",
    phoneCode: "+20",
    name: "Egypt",
    native: "\u0645\u0635\u0631\u200E",
    vat: 14
  },
  {
    code2: "SV",
    code3: "SLV",
    currency: "USD",
    phoneCode: "+503",
    name: "El Salvador",
    native: "El Salvador",
    vat: 13
  },
  {
    code2: "GQ",
    code3: "GNQ",
    currency: "USD",
    phoneCode: "+240",
    name: "Equatorial Guinea",
    native: "Guinea Ecuatorial",
    vat: 15
  },
  {
    code2: "ER",
    code3: "ERI",
    currency: "USD",
    phoneCode: "+291",
    name: "Eritrea",
    native: "\u12A4\u122D\u1275\u122B",
    vat: 5
  },
  {
    code2: "EE",
    code3: "EST",
    currency: "EUR",
    phoneCode: "+372",
    name: "Estonia",
    native: "Eesti",
    vat: 20
  },
  {
    code2: "ET",
    code3: "ETH",
    currency: "USD",
    phoneCode: "+251",
    name: "Ethiopia",
    native: "\u12A2\u1275\u12EE\u1335\u12EB",
    vat: 15
  },
  {
    code2: "FO",
    code3: "FRO",
    currency: "USD",
    phoneCode: "+298",
    name: "Faroe Islands",
    native: "F\xF8royar",
    vat: 25
  },
  {
    code2: "FJ",
    code3: "FJI",
    currency: "USD",
    phoneCode: "+679",
    name: "Fiji",
    native: "Fiji",
    vat: 9
  },
  {
    code2: "FI",
    code3: "FIN",
    currency: "EUR",
    phoneCode: "+358",
    name: "Finland",
    native: "Suomi",
    vat: 24
  },
  {
    code2: "FR",
    code3: "FRA",
    currency: "EUR",
    phoneCode: "+33",
    name: "France",
    native: "France",
    vat: 20
  },
  {
    code2: "GF",
    code3: "GUF",
    currency: "USD",
    phoneCode: "+594",
    name: "French Guiana",
    native: "Guyane fran\xE7aise",
    vat: 14
  },
  {
    code2: "PF",
    code3: "PYF",
    currency: "USD",
    phoneCode: "+689",
    name: "French Polynesia",
    native: "Polyn\xE9sie fran\xE7aise",
    vat: 16
  },
  {
    code2: "GA",
    code3: "GAB",
    currency: "USD",
    phoneCode: "+241",
    name: "Gabon",
    native: "Gabon",
    vat: 18
  },
  {
    code2: "GM",
    code3: "GMB",
    currency: "USD",
    phoneCode: "+220",
    name: "Gambia",
    native: "Gambia",
    vat: 15
  },
  {
    code2: "GE",
    code3: "GEO",
    currency: "USD",
    phoneCode: "+995",
    name: "Georgia",
    native: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
    vat: 18
  },
  {
    code2: "DE",
    code3: "DEU",
    currency: "EUR",
    phoneCode: "+49",
    name: "Germany",
    native: "Deutschland",
    vat: 19,
    priority: 1
  },
  {
    code2: "GH",
    code3: "GHA",
    currency: "USD",
    phoneCode: "+233",
    name: "Ghana",
    native: "Ghana",
    vat: 12.5
  },
  {
    code2: "GR",
    code3: "GRC",
    currency: "EUR",
    phoneCode: "+30",
    name: "Greece",
    native: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
    vat: 12.5
  },
  {
    code2: "GD",
    code3: "GRD",
    currency: "USD",
    phoneCode: "+1",
    name: "Grenada",
    native: "Grenada",
    vat: 15
  },
  {
    code2: "GP",
    code3: "GLP",
    currency: "USD",
    phoneCode: "+590",
    name: "Guadeloupe",
    native: "Guadeloupe",
    vat: 8.5
  },
  {
    code2: "GU",
    code3: "GUM",
    currency: "USD",
    phoneCode: "+1",
    name: "Guam",
    native: "Guam",
    vat: 2
  },
  {
    code2: "GT",
    code3: "GTM",
    currency: "USD",
    phoneCode: "+502",
    name: "Guatemala",
    native: "Guatemala",
    vat: 12
  },
  {
    code2: "GN",
    code3: "GIN",
    currency: "USD",
    phoneCode: "+224",
    name: "Guinea",
    native: "Guin\xE9e",
    vat: 18
  },
  {
    code2: "GW",
    code3: "GNB",
    currency: "USD",
    phoneCode: "+245",
    name: "Guinea-Bissau",
    native: "Guin\xE9-Bissau",
    vat: 15
  },
  {
    code2: "GY",
    code3: "GUY",
    currency: "USD",
    phoneCode: "+592",
    name: "Guyana",
    native: "Guyana",
    vat: 14
  },
  {
    code2: "HT",
    code3: "HTI",
    currency: "USD",
    phoneCode: "+509",
    name: "Haiti",
    native: "Ha\xEFti",
    vat: 10,
    sanctions: true
  },
  {
    code2: "HN",
    code3: "HND",
    currency: "USD",
    phoneCode: "+504",
    name: "Honduras",
    native: "Honduras",
    vat: 15
  },
  {
    code2: "HU",
    code3: "HUN",
    currency: "HUF",
    phoneCode: "+36",
    name: "Hungary",
    native: "Magyarorsz\xE1g",
    vat: 27
  },
  {
    code2: "IS",
    code3: "ISL",
    currency: "EUR",
    phoneCode: "+354",
    name: "Iceland",
    native: "\xCDsland",
    vat: 24
  },
  {
    code2: "IN",
    code3: "IND",
    currency: "USD",
    phoneCode: "+91",
    name: "India",
    native: "\u092D\u093E\u0930\u0924",
    vat: 8
  },
  {
    code2: "ID",
    code3: "IDN",
    currency: "USD",
    phoneCode: "+62",
    name: "Indonesia",
    native: "Indonesia",
    vat: 10
  },
  {
    code2: "IR",
    code3: "IRN",
    currency: "USD",
    phoneCode: "+98",
    name: "Iran",
    native: "\u0627\u06CC\u0631\u0627\u0646",
    vat: 9,
    sanctions: true
  },
  {
    code2: "IQ",
    code3: "IRQ",
    currency: "USD",
    phoneCode: "+964",
    name: "Iraq",
    native: "\u0627\u0644\u0639\u0631\u0627\u0642",
    vat: 15
  },
  {
    code2: "IE",
    code3: "IRL",
    currency: "EUR",
    phoneCode: "+353",
    name: "Ireland",
    native: "\xC9ire",
    vat: 23
  },
  {
    code2: "IM",
    code3: "IMN",
    currency: "GBP",
    phoneCode: "+44",
    name: "Isle of Man",
    native: "Isle of Man",
    vat: 20
  },
  {
    code2: "IL",
    code3: "ISR",
    currency: "USD",
    phoneCode: "+972",
    name: "Israel",
    native: "\u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC",
    vat: 17
  },
  {
    code2: "IT",
    code3: "ITA",
    currency: "EUR",
    phoneCode: "+39",
    name: "Italy",
    native: "Italia",
    vat: 22
  },
  {
    code2: "CI",
    code3: "CIV",
    currency: "USD",
    phoneCode: "+225",
    name: "Ivory Coast",
    native: "C\xF4te d'Ivoire",
    vat: 18
  },
  {
    code2: "JM",
    code3: "JAM",
    currency: "USD",
    phoneCode: "+1",
    name: "Jamaica",
    native: "Jamaica",
    vat: 20,
    sanctions: true
  },
  {
    code2: "JP",
    code3: "JPN",
    currency: "USD",
    phoneCode: "+81",
    name: "Japan",
    native: "\u65E5\u672C",
    vat: 10
  },
  {
    code2: "JE",
    code3: "JEY",
    currency: "USD",
    phoneCode: "+44",
    name: "Jersey",
    native: "Jersey",
    vat: 5
  },
  {
    code2: "JO",
    code3: "JOR",
    currency: "USD",
    phoneCode: "+962",
    name: "Jordan",
    native: "\u0627\u0644\u0623\u0631\u062F\u0646",
    vat: 16
  },
  {
    code2: "KZ",
    code3: "KAZ",
    currency: "USD",
    phoneCode: "+7",
    name: "Kazakhstan",
    native: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D",
    vat: 12
  },
  {
    code2: "KE",
    code3: "KEN",
    currency: "USD",
    phoneCode: "+254",
    name: "Kenya",
    native: "Kenya",
    vat: 16
  },
  {
    code2: "KI",
    code3: "KIR",
    currency: "USD",
    phoneCode: "+686",
    name: "Kiribati",
    native: "Kiribati",
    vat: 12.5
  },
  {
    code2: "XK",
    code3: "XKX",
    currency: "EUR",
    phoneCode: "+383",
    name: "Kosovo",
    native: "Republika e Kosov\xEBs",
    vat: 18
  },
  {
    code2: "KW",
    code3: "KWT",
    currency: "USD",
    phoneCode: "+965",
    name: "Kuwait",
    native: "\u0627\u0644\u0643\u0648\u064A\u062A",
    vat: 5
  },
  {
    code2: "KG",
    code3: "KGZ",
    currency: "USD",
    phoneCode: "+996",
    name: "Kyrgyzstan",
    native: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D",
    vat: 12
  },
  {
    code2: "LA",
    code3: "LAO",
    currency: "USD",
    phoneCode: "+856",
    name: "Laos",
    native: "\u0EAA\u0E9B\u0E9B\u0EA5\u0EB2\u0EA7",
    vat: 10
  },
  {
    code2: "LV",
    code3: "LVA",
    currency: "EUR",
    phoneCode: "+371",
    name: "Latvia",
    native: "Latvija",
    vat: 21
  },
  {
    code2: "LB",
    code3: "LBN",
    currency: "USD",
    phoneCode: "+961",
    name: "Lebanon",
    native: "\u0644\u0628\u0646\u0627\u0646",
    vat: 11
  },
  {
    code2: "LS",
    code3: "LSO",
    currency: "USD",
    phoneCode: "+266",
    name: "Lesotho",
    native: "Lesotho",
    vat: 15
  },
  {
    code2: "LR",
    code3: "LBR",
    currency: "USD",
    phoneCode: "+231",
    name: "Liberia",
    native: "Liberia",
    vat: 10
  },
  {
    code2: "LI",
    code3: "LIE",
    currency: "EUR",
    phoneCode: "+423",
    name: "Liechtenstein",
    native: "Liechtenstein",
    vat: 7.7
  },
  {
    code2: "LT",
    code3: "LTU",
    currency: "EUR",
    phoneCode: "+370",
    name: "Lithuania",
    native: "Lietuva",
    vat: 21
  },
  {
    code2: "LU",
    code3: "LUX",
    currency: "EUR",
    phoneCode: "+352",
    name: "Luxembourg",
    native: "Luxembourg",
    vat: 17
  },
  {
    code2: "MK",
    code3: "MKD",
    currency: "EUR",
    phoneCode: "+389",
    name: "Macedonia",
    native: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
    vat: 18
  },
  {
    code2: "MG",
    code3: "MDG",
    currency: "USD",
    phoneCode: "+261",
    name: "Madagascar",
    native: "Madagasikara",
    vat: 20
  },
  {
    code2: "MW",
    code3: "MWI",
    currency: "USD",
    phoneCode: "+265",
    name: "Malawi",
    native: "Malawi",
    vat: 16.5
  },
  {
    code2: "MY",
    code3: "MYS",
    currency: "USD",
    phoneCode: "+60",
    name: "Malaysia",
    native: "Malaysia",
    vat: 6
  },
  {
    code2: "MV",
    code3: "MDV",
    currency: "USD",
    phoneCode: "+960",
    name: "Maldives",
    native: "Maldives",
    vat: 6
  },
  {
    code2: "ML",
    code3: "MLI",
    currency: "USD",
    phoneCode: "+223",
    name: "Mali",
    native: "Mali",
    vat: 18,
    sanctions: true
  },
  {
    code2: "MT",
    code3: "MLT",
    currency: "EUR",
    phoneCode: "+356",
    name: "Malta",
    native: "Malta",
    vat: 18
  },
  {
    code2: "MQ",
    code3: "MTQ",
    currency: "USD",
    phoneCode: "+596",
    name: "Martinique",
    native: "Martinique",
    vat: 8.5
  },
  {
    code2: "MR",
    code3: "MRT",
    currency: "USD",
    phoneCode: "+222",
    name: "Mauritania",
    native: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
    vat: 16
  },
  {
    code2: "MU",
    code3: "MUS",
    currency: "USD",
    phoneCode: "+230",
    name: "Mauritius",
    native: "Maurice",
    vat: 15
  },
  {
    code2: "MX",
    code3: "MEX",
    currency: "USD",
    phoneCode: "+52",
    name: "Mexico",
    native: "M\xE9xico",
    vat: 16
  },
  {
    code2: "FM",
    code3: "FSM",
    currency: "USD",
    phoneCode: "+691",
    name: "Micronesia",
    native: "Micronesia",
    vat: 5
  },
  {
    code2: "MD",
    code3: "MDA",
    currency: "EUR",
    phoneCode: "+373",
    name: "Moldova",
    native: "Moldova",
    vat: 20
  },
  {
    code2: "MC",
    code3: "MCO",
    currency: "EUR",
    phoneCode: "+377",
    name: "Monaco",
    native: "Monaco",
    vat: 20
  },
  {
    code2: "MN",
    code3: "MNG",
    currency: "USD",
    phoneCode: "+976",
    name: "Mongolia",
    native: "\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441",
    vat: 10
  },
  {
    code2: "ME",
    code3: "MNE",
    currency: "EUR",
    phoneCode: "+382",
    name: "Montenegro",
    native: "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
    vat: 21
  },
  {
    code2: "MS",
    code3: "MSR",
    currency: "USD",
    phoneCode: "+664",
    name: "Montserrat",
    native: "Montserrat",
    vat: 15
  },
  {
    code2: "MA",
    code3: "MAR",
    currency: "USD",
    phoneCode: "+212",
    name: "Morocco",
    native: "\u0627\u0644\u0645\u063A\u0631\u0628",
    vat: 20
  },
  {
    code2: "MZ",
    code3: "MOZ",
    currency: "USD",
    phoneCode: "+258",
    name: "Mozambique",
    native: "Mo\xE7ambique",
    vat: 17,
    sanctions: true
  },
  {
    code2: "NA",
    code3: "NAM",
    currency: "USD",
    phoneCode: "+264",
    name: "Namibia",
    native: "Namibia",
    vat: 15
  },
  {
    code2: "NP",
    code3: "NPL",
    currency: "USD",
    phoneCode: "+977",
    name: "Nepal",
    native: "\u0928\u0947\u092A\u093E\u0932",
    vat: 13
  },
  {
    code2: "NL",
    code3: "NLD",
    currency: "EUR",
    phoneCode: "+31",
    name: "Netherlands",
    native: "Nederland",
    vat: 21
  },
  {
    code2: "NZ",
    code3: "NZL",
    currency: "USD",
    phoneCode: "+64",
    name: "New Zealand",
    native: "New Zealand",
    vat: 15
  },
  {
    code2: "NI",
    code3: "NIC",
    currency: "USD",
    phoneCode: "+505",
    name: "Nicaragua",
    native: "Nicaragua",
    vat: 15
  },
  {
    code2: "NE",
    code3: "NER",
    currency: "USD",
    phoneCode: "+227",
    name: "Niger",
    native: "Niger",
    vat: 19
  },
  {
    code2: "NG",
    code3: "NGA",
    currency: "USD",
    phoneCode: "+234",
    name: "Nigeria",
    native: "Nigeria",
    vat: 7.5,
    sanctions: true
  },
  {
    code2: "NU",
    code3: "NIU",
    currency: "USD",
    phoneCode: "+683",
    name: "Niue",
    native: "Niu\u0113",
    vat: 12.5
  },
  {
    code2: "NF",
    code3: "NFK",
    currency: "USD",
    phoneCode: "+672",
    name: "Norfolk Island",
    native: "Norfolk Island",
    vat: 12
  },
  {
    code2: "KP",
    code3: "PRK",
    currency: "USD",
    phoneCode: "+850",
    name: "North Korea",
    native: "\uBD81\uD55C",
    vat: 10,
    sanctions: true
  },
  {
    code2: "NO",
    code3: "NOR",
    currency: "EUR",
    phoneCode: "+47",
    name: "Norway",
    native: "Norge",
    vat: 25
  },
  {
    code2: "OM",
    code3: "OMN",
    currency: "USD",
    phoneCode: "+968",
    name: "Oman",
    native: "\u0639\u0645\u0627\u0646",
    vat: 5
  },
  {
    code2: "PK",
    code3: "PAK",
    currency: "USD",
    phoneCode: "+92",
    name: "Pakistan",
    native: "Pakistan",
    vat: 17
  },
  {
    code2: "PS",
    code3: "PSE",
    currency: "USD",
    phoneCode: "+970",
    name: "Palestine",
    native: "\u0641\u0644\u0633\u0637\u064A\u0646",
    vat: 16
  },
  {
    code2: "PA",
    code3: "PAN",
    currency: "USD",
    phoneCode: "+507",
    name: "Panama",
    native: "Panam\xE1",
    vat: 7,
    sanctions: true
  },
  {
    code2: "PG",
    code3: "PNG",
    currency: "USD",
    phoneCode: "+675",
    name: "Papua New Guinea",
    native: "Papua Niugini",
    vat: 10
  },
  {
    code2: "PY",
    code3: "PRY",
    currency: "USD",
    phoneCode: "+595",
    name: "Paraguay",
    native: "Paraguay",
    vat: 10
  },
  {
    code2: "PE",
    code3: "PER",
    currency: "USD",
    phoneCode: "+51",
    name: "Peru",
    native: "Per\xFA",
    vat: 18
  },
  {
    code2: "PH",
    code3: "PHL",
    currency: "USD",
    phoneCode: "+63",
    name: "Philippines",
    native: "Pilipinas",
    vat: 12,
    sanctions: true
  },
  {
    code2: "PL",
    code3: "POL",
    currency: "PLN",
    phoneCode: "+48",
    name: "Poland",
    native: "Polska",
    vat: 23,
    priority: 1
  },
  {
    code2: "PT",
    code3: "PRT",
    currency: "EUR",
    phoneCode: "+351",
    name: "Portugal",
    native: "Portugal",
    vat: 23
  },
  {
    code2: "PR",
    code3: "PRI",
    currency: "USD",
    phoneCode: "+1",
    name: "Puerto Rico",
    native: "Puerto Rico",
    vat: 11.5
  },
  {
    code2: "QA",
    code3: "QAT",
    currency: "USD",
    phoneCode: "+974",
    name: "Qatar",
    native: "\u0642\u0637\u0631",
    vat: 5
  },
  {
    code2: "CG",
    code3: "COG",
    currency: "USD",
    phoneCode: "+242",
    name: "Republic of the Congo",
    native: "R\xE9publique du Congo",
    vat: 18
  },
  {
    code2: "RE",
    code3: "REU",
    currency: "USD",
    phoneCode: "+262",
    name: "R\xE9union",
    native: "La R\xE9union",
    vat: 8.5
  },
  {
    code2: "RO",
    code3: "ROU",
    currency: "RON",
    phoneCode: "+40",
    name: "Romania",
    native: "Rom\xE2nia",
    vat: 19
  },
  {
    code2: "RU",
    code3: "RUS",
    currency: "RUB",
    phoneCode: "+7",
    name: "Russia",
    native: "\u0420\u043E\u0441\u0441\u0438\u044F",
    vat: 20,
    sanctions: true
  },
  {
    code2: "RW",
    code3: "RWA",
    currency: "USD",
    phoneCode: "+250",
    name: "Rwanda",
    native: "Rwanda",
    vat: 18
  },
  {
    code2: "BL",
    code3: "BLM",
    currency: "USD",
    phoneCode: "+590",
    name: "Saint Barth\xE9lemy",
    native: "Saint-Barth\xE9lemy",
    vat: 8.5
  },
  {
    code2: "KN",
    code3: "KNA",
    currency: "USD",
    phoneCode: "+869",
    name: "Saint Kitts and Nevis",
    native: "Saint Kitts and Nevis",
    vat: 17
  },
  {
    code2: "LC",
    code3: "LCA",
    currency: "USD",
    phoneCode: "+1",
    name: "Saint Lucia",
    native: "Saint Lucia",
    vat: 12.5
  },
  {
    code2: "MF",
    code3: "MAF",
    currency: "USD",
    phoneCode: "+590",
    name: "Saint Martin",
    native: "Saint-Martin",
    vat: 15
  },
  {
    code2: "VC",
    code3: "VCT",
    currency: "USD",
    phoneCode: "+1",
    name: "Saint Vincent and the Grenadines",
    native: "Saint Vincent and the Grenadines",
    vat: 16
  },
  {
    code2: "WS",
    code3: "WSM",
    currency: "USD",
    phoneCode: "+685",
    name: "Samoa",
    native: "Samoa",
    vat: 15
  },
  {
    code2: "SM",
    code3: "SMR",
    currency: "USD",
    phoneCode: "+378",
    name: "San Marino",
    native: "San Marino",
    vat: 17
  },
  {
    code2: "SA",
    code3: "SAU",
    currency: "USD",
    phoneCode: "+966",
    name: "Saudi Arabia",
    native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
    vat: 5
  },
  {
    code2: "SN",
    code3: "SEN",
    currency: "USD",
    phoneCode: "+221",
    name: "Senegal",
    native: "S\xE9n\xE9gal",
    vat: 18,
    sanctions: true
  },
  {
    code2: "RS",
    code3: "SRB",
    currency: "EUR",
    phoneCode: "+381",
    name: "Serbia",
    native: "\u0421\u0440\u0431\u0438\u0458\u0430",
    vat: 20
  },
  {
    code2: "SC",
    code3: "SYC",
    currency: "USD",
    phoneCode: "+248",
    name: "Seychelles",
    native: "Seychelles",
    vat: 15
  },
  {
    code2: "SL",
    code3: "SLE",
    currency: "USD",
    phoneCode: "+232",
    name: "Sierra Leone",
    native: "Sierra Leone",
    vat: 15
  },
  {
    code2: "SG",
    code3: "SGP",
    currency: "USD",
    phoneCode: "+65",
    name: "Singapore",
    native: "Singapore",
    vat: 7
  },
  {
    code2: "SX",
    code3: "SXM",
    currency: "USD",
    phoneCode: "+1",
    name: "Sint Maarten",
    native: "Sint Maarten",
    vat: 5
  },
  {
    code2: "SK",
    code3: "SVK",
    currency: "EUR",
    phoneCode: "+421",
    name: "Slovakia",
    native: "Slovensko",
    vat: 20,
    priority: 1
  },
  {
    code2: "SI",
    code3: "SVN",
    currency: "EUR",
    phoneCode: "+386",
    name: "Slovenia",
    native: "Slovenija",
    vat: 22
  },
  {
    code2: "SO",
    code3: "SOM",
    currency: "USD",
    phoneCode: "+252",
    name: "Somalia",
    native: "Soomaaliya",
    vat: 10
  },
  {
    code2: "ZA",
    code3: "ZAF",
    currency: "USD",
    phoneCode: "+27",
    name: "South Africa",
    native: "South Africa",
    vat: 15,
    sanctions: true
  },
  {
    code2: "KR",
    code3: "KOR",
    currency: "USD",
    phoneCode: "+82",
    name: "South Korea",
    native: "\uB300\uD55C\uBBFC\uAD6D",
    vat: 10
  },
  {
    code2: "SS",
    code3: "SSD",
    currency: "USD",
    phoneCode: "+211",
    name: "South Sudan",
    native: "South Sudan",
    vat: 15,
    sanctions: true
  },
  {
    code2: "ES",
    code3: "ESP",
    currency: "EUR",
    phoneCode: "+34",
    name: "Spain",
    native: "Espa\xF1a",
    vat: 21
  },
  {
    code2: "LK",
    code3: "LKA",
    currency: "USD",
    phoneCode: "+94",
    name: "Sri Lanka",
    native: "\u015Br\u012B la\u1E43k\u0101va",
    vat: 8
  },
  {
    code2: "SD",
    code3: "SDN",
    currency: "USD",
    phoneCode: "+249",
    name: "Sudan",
    native: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
    vat: 17
  },
  {
    code2: "SR",
    code3: "SUR",
    currency: "USD",
    phoneCode: "+597",
    name: "Suriname",
    native: "Suriname",
    vat: 10
  },
  {
    code2: "SJ",
    code3: "SJM",
    currency: "USD",
    phoneCode: "+47",
    name: "Svalbard and Jan Mayen",
    native: "Svalbard og Jan Mayen",
    vat: 25
  },
  {
    code2: "SZ",
    code3: "SWZ",
    currency: "USD",
    phoneCode: "+268",
    name: "Swaziland",
    native: "Eswatini",
    vat: 15
  },
  {
    code2: "SE",
    code3: "SWE",
    currency: "SEK",
    phoneCode: "+46",
    name: "Sweden",
    native: "Sverige",
    vat: 25
  },
  {
    code2: "CH",
    code3: "CHE",
    currency: "CHF",
    phoneCode: "+41",
    name: "Switzerland",
    native: "Schweiz",
    vat: 7.7
  },
  {
    code2: "TW",
    code3: "TWN",
    currency: "USD",
    phoneCode: "+886",
    name: "Taiwan",
    native: "\u81FA\u7063",
    vat: 5
  },
  {
    code2: "TJ",
    code3: "TJK",
    currency: "USD",
    phoneCode: "+992",
    name: "Tajikistan",
    native: "\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D",
    vat: 15
  },
  {
    code2: "TZ",
    code3: "TZA",
    currency: "USD",
    phoneCode: "+255",
    name: "Tanzania",
    native: "Tanzania",
    vat: 18,
    sanctions: true
  },
  {
    code2: "TH",
    code3: "THA",
    currency: "USD",
    phoneCode: "+66",
    name: "Thailand",
    native: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
    vat: 7
  },
  {
    code2: "TG",
    code3: "TGO",
    currency: "USD",
    phoneCode: "+228",
    name: "Togo",
    native: "Togo",
    vat: 18
  },
  {
    code2: "TO",
    code3: "TON",
    currency: "USD",
    phoneCode: "+676",
    name: "Tonga",
    native: "Tonga",
    vat: 15
  },
  {
    code2: "TT",
    code3: "TTO",
    currency: "USD",
    phoneCode: "+868",
    name: "Trinidad and Tobago",
    native: "Trinidad and Tobago",
    vat: 12.5,
    sanctions: true
  },
  {
    code2: "TN",
    code3: "TUN",
    currency: "USD",
    phoneCode: "+216",
    name: "Tunisia",
    native: "\u062A\u0648\u0646\u0633",
    vat: 19
  },
  {
    code2: "TR",
    code3: "TUR",
    currency: "USD",
    phoneCode: "+90",
    name: "Turkey",
    native: "T\xFCrkiye",
    vat: 18
  },
  {
    code2: "TM",
    code3: "TKM",
    currency: "USD",
    phoneCode: "+993",
    name: "Turkmenistan",
    native: "T\xFCrkmenistan",
    vat: 15
  },
  {
    code2: "UM",
    code3: "UMI",
    currency: "USD",
    phoneCode: "+1",
    name: "U.S. Minor Outlying Islands",
    native: "United States Minor Outlying Islands",
    vat: 4
  },
  {
    code2: "VI",
    code3: "VIR",
    currency: "USD",
    phoneCode: "+1",
    name: "U.S. Virgin Islands",
    native: "United States Virgin Islands",
    vat: 4
  },
  {
    code2: "UG",
    code3: "UGA",
    currency: "USD",
    phoneCode: "+256",
    name: "Uganda",
    native: "Uganda",
    vat: 18,
    sanctions: true
  },
  {
    code2: "UA",
    code3: "UKR",
    currency: "UAH",
    phoneCode: "+380",
    name: "Ukraine",
    native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
    vat: 20
  },
  {
    code2: "AE",
    code3: "ARE",
    currency: "USD",
    phoneCode: "+971",
    name: "United Arab Emirates",
    native: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
    vat: 5,
    sanctions: true
  },
  {
    code2: "GB",
    code3: "GBR",
    currency: "GBP",
    phoneCode: "+44",
    name: "United Kingdom",
    native: "United Kingdom",
    vat: 20
  },
  {
    code2: "UZ",
    code3: "UZB",
    currency: "USD",
    phoneCode: "+998",
    name: "Uzbekistan",
    native: "O'zbekiston",
    vat: 20
  },
  {
    code2: "VU",
    code3: "VUT",
    currency: "USD",
    phoneCode: "+678",
    name: "Vanuatu",
    native: "Vanuatu",
    vat: 15,
    sanctions: true
  },
  {
    code2: "VE",
    code3: "VEN",
    currency: "USD",
    phoneCode: "+58",
    name: "Venezuela",
    native: "Venezuela",
    vat: 16
  },
  {
    code2: "VN",
    code3: "VNM",
    currency: "USD",
    phoneCode: "+84",
    name: "Vietnam",
    native: "Vi\u1EC7t Nam",
    vat: 10,
    sanctions: true
  },
  {
    code2: "WF",
    code3: "WLF",
    currency: "USD",
    phoneCode: "+681",
    name: "Wallis and Futuna",
    native: "Wallis et Futuna",
    vat: 6
  },
  {
    code2: "EH",
    code3: "ESH",
    currency: "USD",
    phoneCode: "+212",
    name: "Western Sahara",
    native: "\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629",
    vat: 20
  },
  {
    code2: "YE",
    code3: "YEM",
    currency: "USD",
    phoneCode: "+967",
    name: "Yemen",
    native: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
    vat: 5,
    sanctions: true
  },
  {
    code2: "ZM",
    code3: "ZMB",
    currency: "USD",
    phoneCode: "+260",
    name: "Zambia",
    native: "Zambia",
    vat: 16
  },
  {
    code2: "ZW",
    code3: "ZWE",
    currency: "USD",
    phoneCode: "+263",
    name: "Zimbabwe",
    native: "Zimbabwe",
    vat: 14.5
  }
];

const cryptoNetworks = [
  {
    code: "ETH",
    name: "Ethereum",
    nativeCurrency: "ETH",
    chainId: 1,
    rpcUrl: "https://mainnet.infura.io/v3/",
    explorerUrl: "https://etherscan.io"
  },
  {
    code: "BTC",
    name: "Bitcoin",
    nativeCurrency: "BTC",
    explorerUrl: "https://blockstream.info"
  },
  {
    code: "BSC",
    name: "Binance Smart Chain",
    nativeCurrency: "BNB",
    chainId: 56,
    rpcUrl: "https://bsc-dataseed1.binance.org",
    explorerUrl: "https://bscscan.com"
  },
  {
    code: "POLYGON",
    name: "Polygon",
    nativeCurrency: "MATIC",
    chainId: 137,
    rpcUrl: "https://polygon-rpc.com",
    explorerUrl: "https://polygonscan.com"
  },
  {
    code: "AVALANCHE",
    name: "Avalanche C-Chain",
    nativeCurrency: "AVAX",
    chainId: 43114,
    rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
    explorerUrl: "https://snowtrace.io"
  },
  {
    code: "SOLANA",
    name: "Solana",
    nativeCurrency: "SOL",
    rpcUrl: "https://api.mainnet-beta.solana.com",
    explorerUrl: "https://explorer.solana.com"
  },
  {
    code: "CARDANO",
    name: "Cardano",
    nativeCurrency: "ADA",
    explorerUrl: "https://cardanoscan.io"
  },
  {
    code: "POLKADOT",
    name: "Polkadot",
    nativeCurrency: "DOT",
    explorerUrl: "https://polkadot.subscan.io"
  },
  {
    code: "COSMOS",
    name: "Cosmos Hub",
    nativeCurrency: "ATOM",
    explorerUrl: "https://www.mintscan.io/cosmos"
  },
  {
    code: "ARBITRUM",
    name: "Arbitrum One",
    nativeCurrency: "ETH",
    chainId: 42161,
    rpcUrl: "https://arb1.arbitrum.io/rpc",
    explorerUrl: "https://arbiscan.io"
  },
  {
    code: "OPTIMISM",
    name: "Optimism",
    nativeCurrency: "ETH",
    chainId: 10,
    rpcUrl: "https://mainnet.optimism.io",
    explorerUrl: "https://optimistic.etherscan.io"
  },
  {
    code: "FANTOM",
    name: "Fantom Opera",
    nativeCurrency: "FTM",
    chainId: 250,
    rpcUrl: "https://rpc.ftm.tools",
    explorerUrl: "https://ftmscan.com"
  },
  {
    code: "TRON",
    name: "Tron",
    nativeCurrency: "TRX",
    explorerUrl: "https://tronscan.org"
  },
  {
    code: "NEAR",
    name: "NEAR Protocol",
    nativeCurrency: "NEAR",
    explorerUrl: "https://explorer.near.org"
  },
  {
    code: "ALGORAND",
    name: "Algorand",
    nativeCurrency: "ALGO",
    explorerUrl: "https://algoexplorer.io"
  },
  {
    code: "TEZOS",
    name: "Tezos",
    nativeCurrency: "XTZ",
    explorerUrl: "https://tzstats.com"
  },
  {
    code: "CRONOS",
    name: "Cronos",
    nativeCurrency: "CRO",
    chainId: 25,
    rpcUrl: "https://evm.cronos.org",
    explorerUrl: "https://cronoscan.com"
  },
  {
    code: "MOONBEAM",
    name: "Moonbeam",
    nativeCurrency: "GLMR",
    chainId: 1284,
    rpcUrl: "https://rpc.api.moonbeam.network",
    explorerUrl: "https://moonscan.io"
  },
  {
    code: "AURORA",
    name: "Aurora",
    nativeCurrency: "ETH",
    chainId: 1313161554,
    rpcUrl: "https://mainnet.aurora.dev",
    explorerUrl: "https://aurorascan.dev"
  },
  {
    code: "HARMONY",
    name: "Harmony",
    nativeCurrency: "ONE",
    chainId: 16666e5,
    rpcUrl: "https://api.harmony.one",
    explorerUrl: "https://explorer.harmony.one"
  },
  {
    code: "CELO",
    name: "Celo",
    nativeCurrency: "CELO",
    chainId: 42220,
    rpcUrl: "https://forno.celo.org",
    explorerUrl: "https://explorer.celo.org"
  },
  {
    code: "KAVA",
    name: "Kava EVM",
    nativeCurrency: "KAVA",
    chainId: 2222,
    rpcUrl: "https://evm.kava.io",
    explorerUrl: "https://explorer.kava.io"
  },
  {
    code: "XRP",
    name: "XRP Ledger",
    nativeCurrency: "XRP",
    explorerUrl: "https://xrpscan.com"
  },
  {
    code: "LTC",
    name: "Litecoin",
    nativeCurrency: "LTC",
    explorerUrl: "https://blockchair.com/litecoin"
  },
  {
    code: "DOGE",
    name: "Dogecoin",
    nativeCurrency: "DOGE",
    explorerUrl: "https://dogechain.info"
  }
];

const currencies = [
  // 🔹 FIAT Currencies
  {
    code: "CZK",
    symbol: "K\u010D",
    symbolBefore: false,
    name: "Czech Koruna",
    providers: ["CNB", "currencyLayer", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "EUR",
    symbol: "\u20AC",
    symbolBefore: false,
    name: "Euro",
    providers: ["currencyLayer", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "USD",
    symbol: "$",
    symbolBefore: true,
    name: "United States Dollar",
    providers: ["currencyLayer", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "PLN",
    symbol: "z\u0142",
    symbolBefore: false,
    name: "Polish Z\u0142oty",
    providers: ["currencyLayer", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "RON",
    symbol: "lei",
    symbolBefore: false,
    name: "Romanian Leu",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "GBP",
    symbol: "\xA3",
    symbolBefore: true,
    name: "British Pound Sterling",
    providers: ["currencyLayer", "CNB", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "RUB",
    symbol: "\u20BD",
    symbolBefore: false,
    name: "Russian Ruble",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "HUF",
    symbol: "Ft",
    symbolBefore: false,
    name: "Hungarian Forint",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "CHF",
    symbol: "SFr.",
    symbolBefore: true,
    name: "Swiss Franc",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "DKK",
    symbol: "kr",
    symbolBefore: false,
    name: "Danish Krone",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "SEK",
    symbol: "kr",
    symbolBefore: false,
    name: "Swedish Krona",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "HRK",
    symbol: "kn",
    symbolBefore: false,
    name: "Croatian Kuna",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "NOK",
    symbol: "kr",
    symbolBefore: false,
    name: "Norwegian Krone",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "BGN",
    symbol: "\u043B\u0432",
    symbolBefore: false,
    name: "Bulgarian Lev",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "TRY",
    symbol: "\u20BA",
    symbolBefore: false,
    name: "Turkish Lira",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "AUD",
    symbol: "$",
    symbolBefore: true,
    name: "Australian Dollar",
    providers: ["currencyLayer", "CNB", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "CAD",
    symbol: "$",
    symbolBefore: true,
    name: "Canadian Dollar",
    providers: ["currencyLayer", "CNB", "currencyCloud"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "JPY",
    symbol: "\xA5",
    symbolBefore: true,
    name: "Japanese Yen",
    providers: ["currencyLayer", "CNB"],
    decimals: 0,
    networks: null,
    type: "FIAT"
  },
  {
    code: "CNY",
    symbol: "\xA5",
    symbolBefore: true,
    name: "Chinese Yuan",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "INR",
    symbol: "\u20B9",
    symbolBefore: true,
    name: "Indian Rupee",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "BRL",
    symbol: "R$",
    symbolBefore: true,
    name: "Brazilian Real",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "MXN",
    symbol: "$",
    symbolBefore: true,
    name: "Mexican Peso",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "ZAR",
    symbol: "R",
    symbolBefore: true,
    name: "South African Rand",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "SGD",
    symbol: "$",
    symbolBefore: true,
    name: "Singapore Dollar",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "HKD",
    symbol: "$",
    symbolBefore: true,
    name: "Hong Kong Dollar",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "KRW",
    symbol: "\u20A9",
    symbolBefore: true,
    name: "South Korean Won",
    providers: ["currencyLayer", "CNB"],
    decimals: 0,
    networks: null,
    type: "FIAT"
  },
  {
    code: "MYR",
    symbol: "RM",
    symbolBefore: true,
    name: "Malaysian Ringgit",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "THB",
    symbol: "\u0E3F",
    symbolBefore: true,
    name: "Thai Baht",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "IDR",
    symbol: "Rp",
    symbolBefore: true,
    name: "Indonesian Rupiah",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "PHP",
    symbol: "\u20B1",
    symbolBefore: true,
    name: "Philippine Peso",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "AED",
    symbol: "\u062F.\u0625",
    symbolBefore: false,
    name: "UAE Dirham",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "SAR",
    symbol: "\uFDFC",
    symbolBefore: false,
    name: "Saudi Riyal",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "ILS",
    symbol: "\u20AA",
    symbolBefore: true,
    name: "Israeli New Shekel",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "EGP",
    symbol: "\xA3",
    symbolBefore: true,
    name: "Egyptian Pound",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "NGN",
    symbol: "\u20A6",
    symbolBefore: true,
    name: "Nigerian Naira",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "PKR",
    symbol: "\u20A8",
    symbolBefore: true,
    name: "Pakistani Rupee",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "COP",
    symbol: "$",
    symbolBefore: true,
    name: "Colombian Peso",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "CLP",
    symbol: "$",
    symbolBefore: true,
    name: "Chilean Peso",
    providers: ["currencyLayer", "CNB"],
    decimals: 0,
    networks: null,
    type: "FIAT"
  },
  {
    code: "PEN",
    symbol: "S/",
    symbolBefore: true,
    name: "Peruvian Sol",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "VND",
    symbol: "\u20AB",
    symbolBefore: false,
    name: "Vietnamese Dong",
    providers: ["currencyLayer", "CNB"],
    decimals: 0,
    networks: null,
    type: "FIAT"
  },
  {
    code: "KZT",
    symbol: "\u20B8",
    symbolBefore: false,
    name: "Kazakhstani Tenge",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  {
    code: "UAH",
    symbol: "\u20B4",
    symbolBefore: false,
    name: "Ukrainian Hryvnia",
    providers: ["currencyLayer", "CNB"],
    decimals: 2,
    networks: null,
    type: "FIAT"
  },
  // 🔹 Crypto Currencies
  {
    code: "BTC",
    symbol: "\u20BF",
    symbolBefore: true,
    name: "Bitcoin",
    providers: ["kraken", "binance"],
    decimals: 8,
    networks: ["BTC"],
    type: "CRYPTO"
  },
  {
    code: "ETH",
    symbol: "\u039E",
    symbolBefore: true,
    name: "Ethereum",
    providers: ["kraken", "binance"],
    decimals: 18,
    networks: ["ETH", "ARBITRUM", "OPTIMISM", "POLYGON"],
    type: "CRYPTO"
  },
  {
    code: "ADA",
    symbol: "\u20B3",
    symbolBefore: true,
    name: "Cardano",
    providers: ["kraken", "binance"],
    decimals: 6,
    networks: ["CARDANO"],
    type: "CRYPTO"
  },
  {
    code: "DOT",
    symbol: "\u25CE",
    symbolBefore: true,
    name: "Polkadot",
    providers: ["kraken", "binance"],
    decimals: 10,
    networks: ["POLKADOT"],
    type: "CRYPTO"
  },
  {
    code: "ATOM",
    symbol: "\u269B",
    symbolBefore: true,
    name: "Cosmos",
    providers: ["kraken", "binance"],
    decimals: 6,
    networks: ["COSMOS"],
    type: "CRYPTO"
  },
  {
    code: "XRP",
    symbol: "\u01A6",
    symbolBefore: true,
    name: "Ripple",
    providers: ["kraken", "binance"],
    decimals: 6,
    networks: ["XRP"],
    type: "CRYPTO"
  },
  {
    code: "LTC",
    symbol: "\u0141",
    symbolBefore: true,
    name: "Litecoin",
    providers: ["kraken", "binance"],
    decimals: 8,
    networks: ["LTC"],
    type: "CRYPTO"
  },
  {
    code: "SOL",
    symbol: "\u25CE",
    symbolBefore: true,
    name: "Solana",
    providers: ["kraken", "binance"],
    decimals: 9,
    networks: ["SOLANA"],
    type: "CRYPTO"
  },
  {
    code: "DOGE",
    symbol: "\xD0",
    symbolBefore: true,
    name: "Dogecoin",
    providers: ["kraken", "binance"],
    decimals: 8,
    networks: ["DOGE"],
    type: "CRYPTO"
  },
  {
    code: "MATIC",
    symbol: "M",
    symbolBefore: true,
    name: "Polygon",
    providers: ["kraken", "binance"],
    decimals: 18,
    networks: ["ETH", "POLYGON"],
    type: "CRYPTO"
  },
  {
    code: "AVAX",
    symbol: "\u26F0",
    symbolBefore: true,
    name: "Avalanche",
    providers: ["kraken", "binance"],
    decimals: 18,
    networks: ["AVALANCHE"],
    type: "CRYPTO"
  }
];

const currencyProviders = [
  {
    id: "currencyLayer",
    url: "https://api.currencylayer.com/live?access_key={access_key}&currencies={target}&source={base}"
  },
  {
    id: "currencyCloud",
    url: "https://api.currencycloud.com/v2/rates/detailed?buy_currency={target}&sell_currency={base}"
  },
  {
    id: "kraken",
    url: "https://api.kraken.com/0/public/Ticker?pair={base}{target}"
  },
  {
    id: "binance",
    url: "https://api.binance.com/api/v3/ticker/price?symbol={base}{target}"
  },
  { id: "CNB", url: "https://api.cnb.cz/cnbapi/exrates/daily" }
];

const languages = [
  { code: "en", name: "English", native: "English", cs: "Angli\u010Dtina" },
  { code: "de", name: "German", native: "Deutsch", cs: "N\u011Bm\u010Dina" },
  { code: "cs", name: "Czech", native: "\u010Ce\u0161tina", cs: "\u010Ce\u0161tina" },
  { code: "sk", name: "Slovak", native: "Sloven\u010Dina", cs: "Sloven\u0161tina" },
  { code: "pl", name: "Polish", native: "Polski", cs: "Pol\u0161tina" },
  { code: "hr", name: "Croatian", native: "Hrvatski", cs: "Chorvat\u0161tina" },
  { code: "ru", name: "Russian", native: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439", cs: "Ru\u0161tina" },
  { code: "es", name: "Spanish", native: "Espa\xF1ol", cs: "\u0160pan\u011Bl\u0161tina" },
  { code: "fr", name: "French", native: "Fran\xE7ais", cs: "Francouz\u0161tina" },
  { code: "it", name: "Italian", native: "Italiano", cs: "Ital\u0161tina" },
  { code: "nl", name: "Dutch", native: "Nederlands", cs: "Holand\u0161tina" },
  { code: "ro", name: "Romanian", native: "Rom\xE2n\u0103", cs: "Rumun\u0161tina" },
  { code: "ar", name: "Arabic", native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629", cs: "Arab\u0161tina" },
  { code: "sq", name: "Albanian", native: "Shqip", cs: "Alb\xE1n\u0161tina" },
  { code: "am", name: "Amharic", native: "\u12A0\u121B\u122D\u129B", cs: "Amhar\u0161tina" },
  { code: "bs", name: "Bosnian", native: "Bosanski", cs: "Bosen\u0161tina" },
  { code: "bg", name: "Bulgarian", native: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438", cs: "Bulhar\u0161tina" },
  { code: "ca", name: "Catalan", native: "Catal\xE0", cs: "Katal\xE1n\u0161tina" },
  { code: "da", name: "Danish", native: "Dansk", cs: "D\xE1n\u0161tina" },
  { code: "et", name: "Estonian", native: "Eesti", cs: "Eston\u0161tina" },
  { code: "fi", name: "Finnish", native: "Suomi", cs: "Fin\u0161tina" },
  { code: "el", name: "Greek", native: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC", cs: "\u0158e\u010Dtina" },
  { code: "ka", name: "Georgian", native: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8", cs: "Gruz\xEDn\u0161tina" },
  { code: "he", name: "Hebrew", native: "\u05E2\u05D1\u05E8\u05D9\u05EA", cs: "Hebrej\u0161tina" },
  { code: "hi", name: "Hindi", native: "\u0939\u093F\u0928\u094D\u0926\u0940", cs: "Hind\u0161tina" },
  { code: "ig", name: "Igbo", native: "As\u1EE5s\u1EE5 Igbo", cs: "Igbo" },
  { code: "ja", name: "Japanese", native: "\u65E5\u672C\u8A9E", cs: "Japon\u0161tina" },
  { code: "ku", name: "Kurdish", native: "Kurd\xEE", cs: "Kurd\u0161tina" },
  { code: "ko", name: "Korean", native: "\uD55C\uAD6D\uC5B4", cs: "Korej\u0161tina" },
  { code: "kk", name: "Kazakh", native: "\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456", cs: "Kazach\u0161tina" },
  { code: "hu", name: "Hungarian", native: "Magyar", cs: "Ma\u010Far\u0161tina" },
  { code: "mk", name: "Macedonian", native: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438", cs: "Makedon\u0161tina" },
  {
    code: "lt",
    name: "Lithuanian",
    native: "lietuvi\u0173 kalba",
    cs: "Litev\u0161tina"
  },
  { code: "lv", name: "Latvian", native: "latvie\u0161u valoda", cs: "Loty\u0161\u0161tina" },
  {
    code: "lb",
    name: "Luxembourgish",
    native: "L\xEBtzebuergesch",
    cs: "Lucembur\u0161tina"
  },
  { code: "mn", name: "Mongolian", native: "\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B", cs: "Mongol\u0161tina" },
  { code: "no", name: "Norwegian", native: "Norsk", cs: "Nor\u0161tina" },
  { code: "fa", name: "Persian", native: "\u0641\u0627\u0631\u0633\u06CC", cs: "Per\u0161tina" },
  { code: "pt", name: "Portuguese", native: "Portugu\xEAs", cs: "Portugal\u0161tina" },
  { code: "sl", name: "Slovene", native: "Sloven\u0161\u010Dina", cs: "Slovin\u0161tina" },
  { code: "sr", name: "Serbian", native: "\u0441\u0440\u043F\u0441\u043A\u0438", cs: "Srb\u0161tina" },
  { code: "sv", name: "Swedish", native: "Svenska", cs: "\u0160v\xE9d\u0161tina" },
  { code: "tr", name: "Turkish", native: "T\xFCrk\xE7e", cs: "Ture\u010Dtina" },
  { code: "uk", name: "Ukrainian", native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430", cs: "Ukrajin\u0161tina" },
  { code: "vi", name: "Vietnamese", native: "Ti\u1EBFng Vi\u1EC7t", cs: "Vietnam\u0161tina" },
  { code: "zh", name: "Chinese", native: "\u4E2D\u6587", cs: "\u010C\xEDn\u0161tina" },
  { code: "af", name: "Afrikaans", native: "Afrikaans", cs: "Afrik\xE1n\u0161tina" },
  { code: "hy", name: "Armenian", native: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576", cs: "Arm\xE9n\u0161tina" }
];

const index = {
  __proto__: null
};

const getCurrencyByCode = (code) => {
  return currencies.find((currency) => currency.code === code);
};
const getCurrenciesByType = (type) => {
  return currencies.filter((currency) => currency.type === type);
};
const getFiatCurrencies = () => {
  return currencies.filter((currency) => currency.type === "FIAT");
};
const getCryptoCurrencies = () => {
  return currencies.filter((currency) => currency.type === "CRYPTO");
};
const isFiatCurrency = (code) => {
  const currency = getCurrencyByCode(code);
  return currency?.type === "FIAT";
};
const isCryptoCurrency = (code) => {
  const currency = getCurrencyByCode(code);
  return currency?.type === "CRYPTO";
};
const getNetworkByCode = (code) => {
  return cryptoNetworks.find((network) => network.code === code);
};
const getCurrenciesByNetwork = (networkCode) => {
  return currencies.filter(
    (currency) => currency.networks && currency.networks.includes(networkCode)
  );
};
const getNetworksForCurrency = (currencyCode) => {
  const currency = getCurrencyByCode(currencyCode);
  if (!currency?.networks) return [];
  return cryptoNetworks.filter(
    (network) => currency.networks && currency.networks.includes(network.code)
  );
};
const isMultiChainCurrency = (currencyCode) => {
  const currency = getCurrencyByCode(currencyCode);
  return (currency?.networks?.length || 0) > 1;
};
const formatCurrency = (amount, currencyCode, options) => {
  const currency = getCurrencyByCode(currencyCode);
  if (!currency) return amount.toString();
  const { showSymbol = true, locale = "en-US" } = options || {};
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: currency.decimals,
    maximumFractionDigits: currency.decimals
  }).format(amount);
  if (!showSymbol) return formatted;
  return currency.symbolBefore ? `${currency.symbol}${formatted}` : `${formatted} ${currency.symbol}`;
};
const getCurrencyDecimals = (currencyCode) => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.decimals ?? 2;
};
const getCurrencySymbol = (currencyCode) => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.symbol ?? currencyCode;
};
const isSymbolBefore = (currencyCode) => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.symbolBefore ?? false;
};
const getCurrencyProviders = (currencyCode) => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.providers ?? [];
};
const getCurrenciesByProvider = (providerName) => {
  return currencies.filter(
    (currency) => currency.providers.includes(providerName)
  );
};
const hasProvider = (currencyCode, providerName) => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.providers?.includes(providerName) ?? false;
};
const isValidCurrencyCode = (code) => {
  return currencies.some((currency) => currency.code === code);
};
const isValidNetworkCode = (code) => {
  return cryptoNetworks.some((network) => network.code === code);
};
const validateCurrencyNetworkPair = (currencyCode, networkCode) => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.networks?.includes(networkCode) ?? false;
};
const searchCurrencies = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return currencies.filter(
    (currency) => currency.code.toLowerCase().includes(lowercaseQuery) || currency.name.toLowerCase().includes(lowercaseQuery) || currency.symbol.toLowerCase().includes(lowercaseQuery)
  );
};
const searchNetworks = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return cryptoNetworks.filter(
    (network) => network.code.toLowerCase().includes(lowercaseQuery) || network.name.toLowerCase().includes(lowercaseQuery) || network.nativeCurrency.toLowerCase().includes(lowercaseQuery)
  );
};
const convertCurrencyAmount = (amount, fromDecimals, toDecimals) => {
  const scaleFactor = Math.pow(10, toDecimals - fromDecimals);
  return amount * scaleFactor;
};
const normalizeAmount = (amount, currencyCode, targetDecimals = 8) => {
  const currency = getCurrencyByCode(currencyCode);
  if (!currency) return amount;
  return convertCurrencyAmount(amount, currency.decimals, targetDecimals);
};

const utils = {
  __proto__: null,
  convertCurrencyAmount: convertCurrencyAmount,
  formatCurrency: formatCurrency,
  getCryptoCurrencies: getCryptoCurrencies,
  getCurrenciesByNetwork: getCurrenciesByNetwork,
  getCurrenciesByProvider: getCurrenciesByProvider,
  getCurrenciesByType: getCurrenciesByType,
  getCurrencyByCode: getCurrencyByCode,
  getCurrencyDecimals: getCurrencyDecimals,
  getCurrencyProviders: getCurrencyProviders,
  getCurrencySymbol: getCurrencySymbol,
  getFiatCurrencies: getFiatCurrencies,
  getNetworkByCode: getNetworkByCode,
  getNetworksForCurrency: getNetworksForCurrency,
  hasProvider: hasProvider,
  isCryptoCurrency: isCryptoCurrency,
  isFiatCurrency: isFiatCurrency,
  isMultiChainCurrency: isMultiChainCurrency,
  isSymbolBefore: isSymbolBefore,
  isValidCurrencyCode: isValidCurrencyCode,
  isValidNetworkCode: isValidNetworkCode,
  normalizeAmount: normalizeAmount,
  searchCurrencies: searchCurrencies,
  searchNetworks: searchNetworks,
  validateCurrencyNetworkPair: validateCurrencyNetworkPair
};

const CURRENCY_CODES = [
  ...currencies.map((currency) => currency.code)
];
const COUNTRY_CODES_2 = [
  ...countries.map((country) => country.code2)
];
const COUNTRY_CODES_3 = [
  ...countries.map((country) => country.code3)
];
const COUNTRY_CURRENCIES = [
  ...countries.map((country) => country.currency)
];
const COUNTRY_PHONE_CODES = [
  ...countries.map((country) => country.phoneCode)
];
const COUNTRY_VATS = [
  ...countries.map((country) => country.vat)
];
const BANK_CODES = [...banks.map((bank) => bank.code)];
const LANGUAGE_CODES = [
  ...languages.map((language) => language.code)
];
const CURRENCY_PROVIDER_IDS = [
  ...currencyProviders.map((provider) => provider.id)
];
const CRYPTO_NETWORK_CODES = [
  ...cryptoNetworks.map((network) => network.code)
];
const CURRENCY_TYPES = ["FIAT", "CRYPTO"];
const FIAT_CURRENCIES = currencies.filter((c) => c.type === "FIAT");
const CRYPTO_CURRENCIES = currencies.filter((c) => c.type === "CRYPTO");
const FIAT_CURRENCY_CODES = [
  ...FIAT_CURRENCIES.map((currency) => currency.code)
];
const CRYPTO_CURRENCY_CODES = [
  ...CRYPTO_CURRENCIES.map((currency) => currency.code)
];

export { banks as BANKS, BANK_CODES, index as CODES, countries as COUNTRIES, COUNTRY_CODES_2, COUNTRY_CODES_3, COUNTRY_CURRENCIES, COUNTRY_PHONE_CODES, COUNTRY_VATS, CRYPTO_CURRENCIES, CRYPTO_CURRENCY_CODES, cryptoNetworks as CRYPTO_NETWORKS, CRYPTO_NETWORK_CODES, currencies as CURRENCIES, CURRENCY_CODES, currencyProviders as CURRENCY_PROVIDERS, CURRENCY_PROVIDER_IDS, CURRENCY_TYPES, FIAT_CURRENCIES, FIAT_CURRENCY_CODES, languages as LANGUAGES, LANGUAGE_CODES, utils as UTILS, convertCurrencyAmount, formatCurrency, getCryptoCurrencies, getCurrenciesByNetwork, getCurrenciesByProvider, getCurrenciesByType, getCurrencyByCode, getCurrencyDecimals, getCurrencyProviders, getCurrencySymbol, getFiatCurrencies, getNetworkByCode, getNetworksForCurrency, hasProvider, isCryptoCurrency, isFiatCurrency, isMultiChainCurrency, isSymbolBefore, isValidCurrencyCode, isValidNetworkCode, normalizeAmount, searchCurrencies, searchNetworks, validateCurrencyNetworkPair };
